import React from 'react';
import { useSelector } from 'react-redux';
import {
  percent, _t, formatNumber, toInt, formatFileSizeBinary, getFormatFileSizeFromByte,
} from 'utils';
import PropertiesTableComponent from 'screens/shared/properties-table';
import Progress from 'screens/shared/progress-bar';
import shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/helper';

const DatabaseResourceAllocation = () => {
  const { [ACTIONS_TYPES.DATABASE.GET_QUOTA]: dbQuota = {} } = useSelector((e) => e);
  const { quotaUsage = {}, quotaLimits = {} } = dbQuota || {};

  const generateRow = ({
    name, used, total, unit = '',
  }) => {
    const avg = percent(used, total);

    return [
      name,
      <Progress
        value={avg}
        title={`${formatNumber(Number.isNaN(used) ? 0 : used)}${unit} / ${formatNumber((Number.isNaN(total) ? 0 : total))}${unit} ( ${Math.floor(avg)}% )`}
      />,
    ];
  };

  const iconLabel = ({ label, icon }) => (
    <span>
      {icon && (
        <shared.widgets.Icon name={icon} style={{ color: '#5e5e5e' }} />
      )}
      <span style={{ fontSize: 15 }}>{` ${_t(label)}`}</span>
    </span>
  );

  const getValuesWithFileSize = (total, used) => {
    // compute Gibibyte values to byte * 1024 ** 3
    const totalFormatted = formatFileSizeBinary(total * 1024 ** 3);
    const [value, unit] = totalFormatted.split(' ');
    const usedFormatted = getFormatFileSizeFromByte(used * 1024 ** 3, unit);
    return {
      total: value,
      used: usedFormatted,
      unit,
    };
  };
  const memoryValues = getValuesWithFileSize(quotaLimits?.memory || 0, quotaUsage?.memory || 0);
  const storageValues = getValuesWithFileSize(quotaLimits?.storage || 0, quotaUsage?.storage || 0);

  let contractDetails = [
    {
      name: iconLabel({ label: _t('Postgres Clusters') }),
      total: toInt(quotaLimits?.['count/postgresclusters.dbaas.ionos.com']),
      used: toInt(quotaUsage?.['count/postgresclusters.dbaas.ionos.com']),
    },
    {
      name: iconLabel({ label: _t('MongoDB Clusters') }),
      total: toInt(quotaLimits?.['count/mongoclusters.dbaas.ionos.com']),
      used: toInt(quotaUsage?.['count/mongoclusters.dbaas.ionos.com']),
    },
    {
      name: iconLabel({ label: 'Cores', icon: 'microchip' }),
      total: toInt(quotaLimits?.cpu),
      used: toInt(quotaUsage?.cpu),
    },
    {
      name: iconLabel({ label: 'RAM', icon: 'memory' }),
      total: memoryValues.total,
      used: memoryValues.used,
      unit: memoryValues.unit,
    },
    {
      name: iconLabel({ label: 'Storage', icon: 'hdd' }),
      total: storageValues.total,
      used: storageValues.used,
      unit: storageValues.unit,
    },
  ];

  contractDetails = contractDetails.map(generateRow);

  return (
    <PropertiesTableComponent
      rowWidth={100}
      title={_t('RESOURCE_ALLOCATION')}
      properties={contractDetails}
      margin="0 0 25px"
    />
  );
};

export default DatabaseResourceAllocation;
